module.exports = __webpack_public_path__ + "static/media/lolol_temp_closed.8a5939d8.jpeg";